var _filter, _filter2, _rect, _text, _text2, _g, _g2, _g3, _g4, _g5, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _g6, _g7, _g8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg14SfuArchitecture(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 900 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sfuGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#10b981"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#059669"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "userSfuGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#8b5cf6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#7c3aed"
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "shadowSfu",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 4,
    stdDeviation: 8,
    floodOpacity: 0.3
  }))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "glowSfu",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 500,
    fill: "#0f172a"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 450,
    y: 40,
    textAnchor: "middle",
    fill: "#f8fafc",
    fontFamily: "system-ui, sans-serif",
    fontSize: 24,
    fontWeight: "bold"
  }, "\n    SFU - Selective Forwarding Unit\n  ")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 450,
    y: 65,
    textAnchor: "middle",
    fill: "#34d399",
    fontFamily: "system-ui, sans-serif",
    fontSize: 14
  }, "\n    Server forwards streams without mixing\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(450, 250)",
    filter: "url(#shadowSfu)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 70,
    fill: "url(#sfuGrad)",
    filter: "url(#glowSfu)"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 70,
    fill: "none",
    stroke: "#6ee7b7",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "70;80;70",
    dur: "2s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0.3;1",
    dur: "2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("text", {
    y: -15,
    textAnchor: "middle",
    fill: "#fff",
    fontFamily: "system-ui, sans-serif",
    fontSize: 20,
    fontWeight: "bold"
  }, "SFU"), /*#__PURE__*/React.createElement("text", {
    y: 10,
    textAnchor: "middle",
    fill: "#d1fae5",
    fontFamily: "system-ui, sans-serif",
    fontSize: 12
  }, "Media Router"), /*#__PURE__*/React.createElement("text", {
    y: 30,
    textAnchor: "middle",
    fill: "#a7f3d0",
    fontFamily: "system-ui, sans-serif",
    fontSize: 10
  }, "Forwards Only"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(200, 150)",
    filter: "url(#shadowSfu)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 35,
    fill: "url(#userSfuGrad)"
  }), /*#__PURE__*/React.createElement("text", {
    y: 5,
    textAnchor: "middle",
    fill: "#fff",
    fontFamily: "system-ui, sans-serif",
    fontSize: 14,
    fontWeight: "bold"
  }, "A"), /*#__PURE__*/React.createElement("rect", {
    x: -25,
    y: 45,
    width: 50,
    height: 25,
    rx: 4,
    fill: "#2e1065"
  }), /*#__PURE__*/React.createElement("text", {
    y: 62,
    textAnchor: "middle",
    fill: "#c4b5fd",
    fontFamily: "system-ui, sans-serif",
    fontSize: 8
  }, "\u21911 \u21933"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(700, 150)",
    filter: "url(#shadowSfu)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 35,
    fill: "url(#userSfuGrad)"
  }), /*#__PURE__*/React.createElement("text", {
    y: 5,
    textAnchor: "middle",
    fill: "#fff",
    fontFamily: "system-ui, sans-serif",
    fontSize: 14,
    fontWeight: "bold"
  }, "B"), /*#__PURE__*/React.createElement("rect", {
    x: -25,
    y: 45,
    width: 50,
    height: 25,
    rx: 4,
    fill: "#2e1065"
  }), /*#__PURE__*/React.createElement("text", {
    y: 62,
    textAnchor: "middle",
    fill: "#c4b5fd",
    fontFamily: "system-ui, sans-serif",
    fontSize: 8
  }, "\u21911 \u21933"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(700, 350)",
    filter: "url(#shadowSfu)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 35,
    fill: "url(#userSfuGrad)"
  }), /*#__PURE__*/React.createElement("text", {
    y: 5,
    textAnchor: "middle",
    fill: "#fff",
    fontFamily: "system-ui, sans-serif",
    fontSize: 14,
    fontWeight: "bold"
  }, "C"), /*#__PURE__*/React.createElement("rect", {
    x: -25,
    y: 45,
    width: 50,
    height: 25,
    rx: 4,
    fill: "#2e1065"
  }), /*#__PURE__*/React.createElement("text", {
    y: 62,
    textAnchor: "middle",
    fill: "#c4b5fd",
    fontFamily: "system-ui, sans-serif",
    fontSize: 8
  }, "\u21911 \u21933"))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(200, 350)",
    filter: "url(#shadowSfu)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 35,
    fill: "url(#userSfuGrad)"
  }), /*#__PURE__*/React.createElement("text", {
    y: 5,
    textAnchor: "middle",
    fill: "#fff",
    fontFamily: "system-ui, sans-serif",
    fontSize: 14,
    fontWeight: "bold"
  }, "D"), /*#__PURE__*/React.createElement("rect", {
    x: -25,
    y: 45,
    width: 50,
    height: 25,
    rx: 4,
    fill: "#2e1065"
  }), /*#__PURE__*/React.createElement("text", {
    y: 62,
    textAnchor: "middle",
    fill: "#c4b5fd",
    fontFamily: "system-ui, sans-serif",
    fontSize: 8
  }, "\u21911 \u21933"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 235,
    y1: 155,
    x2: 380,
    y2: 235,
    stroke: "#f472b6",
    strokeWidth: 3,
    strokeDasharray: "6,3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;-18",
    dur: "0.8s",
    repeatCount: "indefinite"
  }))), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 665,
    y1: 155,
    x2: 520,
    y2: 235,
    stroke: "#a78bfa",
    strokeWidth: 3,
    strokeDasharray: "6,3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;-18",
    dur: "0.8s",
    repeatCount: "indefinite"
  }))), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 665,
    y1: 345,
    x2: 520,
    y2: 265,
    stroke: "#fbbf24",
    strokeWidth: 3,
    strokeDasharray: "6,3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;-18",
    dur: "0.8s",
    repeatCount: "indefinite"
  }))), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 235,
    y1: 345,
    x2: 380,
    y2: 265,
    stroke: "#22d3ee",
    strokeWidth: 3,
    strokeDasharray: "6,3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;-18",
    dur: "0.8s",
    repeatCount: "indefinite"
  }))), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 385,
    y1: 225,
    x2: 235,
    y2: 160,
    stroke: "#a78bfa",
    strokeWidth: 2,
    strokeDasharray: "4,2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;12",
    dur: "0.6s",
    repeatCount: "indefinite"
  }))), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 390,
    y1: 220,
    x2: 240,
    y2: 155,
    stroke: "#fbbf24",
    strokeWidth: 2,
    strokeDasharray: "4,2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;12",
    dur: "0.6s",
    repeatCount: "indefinite"
  }))), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 395,
    y1: 215,
    x2: 245,
    y2: 150,
    stroke: "#22d3ee",
    strokeWidth: 2,
    strokeDasharray: "4,2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;12",
    dur: "0.6s",
    repeatCount: "indefinite"
  }))), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 515,
    y1: 225,
    x2: 665,
    y2: 160,
    stroke: "#f472b6",
    strokeWidth: 2,
    strokeDasharray: "4,2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;12",
    dur: "0.6s",
    repeatCount: "indefinite"
  }))), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 510,
    y1: 220,
    x2: 660,
    y2: 155,
    stroke: "#fbbf24",
    strokeWidth: 2,
    strokeDasharray: "4,2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;12",
    dur: "0.6s",
    repeatCount: "indefinite"
  }))), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 505,
    y1: 215,
    x2: 655,
    y2: 150,
    stroke: "#22d3ee",
    strokeWidth: 2,
    strokeDasharray: "4,2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;12",
    dur: "0.6s",
    repeatCount: "indefinite"
  }))), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 515,
    y1: 275,
    x2: 665,
    y2: 340,
    stroke: "#f472b6",
    strokeWidth: 2,
    strokeDasharray: "4,2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;12",
    dur: "0.6s",
    repeatCount: "indefinite"
  }))), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 510,
    y1: 280,
    x2: 660,
    y2: 345,
    stroke: "#a78bfa",
    strokeWidth: 2,
    strokeDasharray: "4,2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;12",
    dur: "0.6s",
    repeatCount: "indefinite"
  }))), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 505,
    y1: 285,
    x2: 655,
    y2: 350,
    stroke: "#22d3ee",
    strokeWidth: 2,
    strokeDasharray: "4,2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;12",
    dur: "0.6s",
    repeatCount: "indefinite"
  }))), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 385,
    y1: 275,
    x2: 235,
    y2: 340,
    stroke: "#f472b6",
    strokeWidth: 2,
    strokeDasharray: "4,2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;12",
    dur: "0.6s",
    repeatCount: "indefinite"
  }))), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 390,
    y1: 280,
    x2: 240,
    y2: 345,
    stroke: "#a78bfa",
    strokeWidth: 2,
    strokeDasharray: "4,2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;12",
    dur: "0.6s",
    repeatCount: "indefinite"
  }))), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 395,
    y1: 285,
    x2: 245,
    y2: 350,
    stroke: "#fbbf24",
    strokeWidth: 2,
    strokeDasharray: "4,2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;12",
    dur: "0.6s",
    repeatCount: "indefinite"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(450, 360)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -80,
    y: -15,
    width: 160,
    height: 30,
    rx: 6,
    fill: "#064e3b"
  }), /*#__PURE__*/React.createElement("text", {
    y: 5,
    textAnchor: "middle",
    fill: "#6ee7b7",
    fontFamily: "system-ui, sans-serif",
    fontSize: 11,
    fontWeight: 600
  }, "No Mixing = Low Latency"))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(80, 440)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 50,
    rx: 8,
    fill: "#022c22"
  }), /*#__PURE__*/React.createElement("text", {
    x: 15,
    y: 22,
    fill: "#34d399",
    fontFamily: "system-ui, sans-serif",
    fontSize: 12,
    fontWeight: "bold"
  }, "\u2713 Pros:"), /*#__PURE__*/React.createElement("text", {
    x: 15,
    y: 40,
    fill: "#94a3b8",
    fontFamily: "system-ui, sans-serif",
    fontSize: 11
  }, "Low latency \u2022 Full quality \u2022 Scalable server"))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(500, 440)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 50,
    rx: 8,
    fill: "#1c1917"
  }), /*#__PURE__*/React.createElement("text", {
    x: 15,
    y: 22,
    fill: "#fbbf24",
    fontFamily: "system-ui, sans-serif",
    fontSize: 12,
    fontWeight: "bold"
  }, "\u26A1 Trade-off:"), /*#__PURE__*/React.createElement("text", {
    x: 15,
    y: 40,
    fill: "#94a3b8",
    fontFamily: "system-ui, sans-serif",
    fontSize: 11
  }, "Higher client bandwidth (receives N-1 streams)"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg14SfuArchitecture);
export default __webpack_public_path__ + "static/media/14-sfu-architecture.8fab7c3eec0b2087725e8c58c1556110.svg";
export { ForwardRef as ReactComponent };